import { ContextMenuButton } from '@ordr-as/umami-react/context-menu-button';
import type { Dispatch, SetStateAction } from 'react';
import DiscountMenuItem from './DiscountMenuItem';
import EmptyCartMenuItem from './EmptyCartMenuItem';
import WastageMenuItem from './WastageMenuItem';

interface OptionsContextMenuProps {
  setOpenWasteDialog: Dispatch<SetStateAction<boolean>>;
  setOpenEmptyCartDialog: Dispatch<SetStateAction<boolean>>;
  setOpenDiscountDialog: Dispatch<SetStateAction<boolean>>;
}

const OptionsContextMenu = (props: OptionsContextMenuProps) => {
  const { setOpenWasteDialog, setOpenEmptyCartDialog, setOpenDiscountDialog } = props;

  return (
    <ContextMenuButton label="" backdrop={false} className="h-[40px] border-none">
      <DiscountMenuItem setOpenDiscountDialog={setOpenDiscountDialog} />
      <WastageMenuItem setOpenWasteDialog={setOpenWasteDialog} />
      <EmptyCartMenuItem setOpenEmptyCartDialog={setOpenEmptyCartDialog} />
    </ContextMenuButton>
  );
};

export default OptionsContextMenu;
